class ProductReviews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.rating = document.querySelector('[data-oke-reviews-toggle]');

    if (!this.rating) return;

    this.rating.addEventListener('click', this.scrollToReviews.bind(this));

    this.rating.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.scrollToReviews();
      }
    });
  }

  scrollToReviews() {
    const reviews = document.querySelector('#reviews');

    if (!reviews) return;

    reviews.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

if (!customElements.get('product-reviews')) {
  customElements.define('product-reviews', ProductReviews);
}